import "./shell/home-control.css";
import { createApp } from "./app/create-app";
import { completeOpenRouterPopupCallback } from "./creator/openrouter";

if (completeOpenRouterPopupCallback()) {
  // The opener receives the one-time code; this popup never receives the key.
} else {
  const root = document.querySelector<HTMLElement>("#app");
  if (!root) {
    throw new Error("Missing #app root");
  }

  createApp(root);
}
